import { render, staticRenderFns } from "./_quote.vue?vue&type=template&id=9ff31282&"
import script from "./_quote.vue?vue&type=script&lang=js&"
export * from "./_quote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports